export interface ApiErrorDetail {
    data?: unknown[];
    message?: string;
    fields?: unknown[];
    code?: string | number;
}

export class ApiError extends Error {
    error?: unknown;
    response?: unknown;

    status?: number;
    statusText?: string;

    data?: unknown[];
    fields?: unknown[];
    code?: string | number;

    constructor(params: {
        error?: unknown;
        response?: unknown;

        status?: number;
        statusText?: string;

        data?: unknown[];
        message: string;
        fields?: unknown[];
        code?: string | number;
    }) {
        super(params.message ?? 'API Error');

        this.error = params.error;
        this.response = params.response;

        this.status = params.status;
        this.statusText = params.statusText;

        this.name = 'ApiError';
        this.data = params.data ?? [];
        this.fields = params.fields ?? [];
        this.code = params.code;
    }
}
